// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__I0Z1W","containerItemsCenter":"Skeleton_containerItemsCenter__2779n"};